import React from "react";
import { Link } from "react-router-dom";
import HeaderWithSearch from "./HeaderWithSearch";
import ImageWithFallback from "./ImageWithFallback";
import businessCardPreview from "./Business-card/Untitled-design.png";

function VivaanWebDevelopment() {
  return (
    <>
      <HeaderWithSearch />
      <main
        style={{
          minHeight: "100vh",
          width: "100%",
          background: "linear-gradient(180deg, #e3f0fc 0%, #fafdff 100%)",
          padding: 0,
          margin: 0,
        }}
      >
        <section
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "60vh",
            padding: "60px 0 40px 0",
          }}
        >
          <h1
            style={{
              fontSize: "3rem",
              fontWeight: "bold",
              marginBottom: 12,
              textAlign: "center",
            }}
          >
            Vivaan's Web Development
          </h1>
          <p
            style={{
              fontSize: "1.3rem",
              color: "#333",
              marginBottom: 32,
              maxWidth: 700,
              textAlign: "center",
            }}
          >
            Explore web projects built with HTML, CSS, and React.
          </p>

          <Link to="/business-card" style={{ textDecoration: "none", color: "inherit" }}>
            <div
              style={{
                background: "#fff",
                borderRadius: 18,
                boxShadow: "0 2px 16px rgba(0,0,0,0.07)",
                padding: 24,
                width: 340,
                textAlign: "center",
              }}
            >
              <div
                style={{
                  width: "100%",
                  height: 220,
                  borderRadius: 18,
                  marginBottom: 18,
                  overflow: "hidden",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  background: "#f4f8ff",
                }}
              >
                <ImageWithFallback
                  src={businessCardPreview}
                  alt="Business Card Preview"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    borderRadius: 18,
                  }}
                />
              </div>
              <h2
                style={{
                  fontSize: "1.3rem",
                  fontWeight: 600,
                  marginBottom: 8,
                }}
              >
                Business Card
              </h2>
              <p
                style={{
                  fontSize: "1.05rem",
                  color: "#444",
                  marginBottom: 0,
                }}
              >
                A simple business card design project.
              </p>
            </div>
          </Link>
        </section>
      </main>
    </>
  );
}

export default VivaanWebDevelopment;
